import { useState } from "react"
import { useAuth0 } from "@auth0/auth0-react"
import { parseApiError } from "../../lib/apiErrors"

export const useCreateResume = () => {
  const [creatingResume, setCreatingResume] = useState(false)
  const [createResumeError, setCreateResumeError] = useState(null)
  const { getAccessTokenSilently } = useAuth0()
  const apiUrl = process.env.REACT_APP_API_URL

  const createResume = async (resume) => {
    setCreatingResume(true)
    setCreateResumeError(null)

    try {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          audience: process.env.REACT_APP_API_AUDIENCE,
        },
      })

      const response = await fetch(`${apiUrl}/api/resumes`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(resume),
      })

      if (!response.ok) {
        throw await parseApiError(response, "Failed to create resume")
      }

      return await response.json()
    } catch (err) {
      setCreateResumeError(err.message)
      throw err
    } finally {
      setCreatingResume(false)
    }
  }

  return { createResume, creatingResume, createResumeError }
}
